import { ComponentProps, memo } from 'react'
import { Link as RouterLink } from '@tanstack/react-router'

import { BaseLink } from './BaseLink'
import { IGeneralProps } from './types'

type ILinkProps = {
  to: ComponentProps<typeof RouterLink>['to']
} & IGeneralProps

export const Link = memo(function Link({ to, children, testId, onClick, ...props }: ILinkProps) {
  return (
    <BaseLink {...props} childrenContent={children} onClick={onClick}>
      {({ content, ...renderProps }) => (
        <RouterLink
          // TODO какая-то проблема в типизации event
          // @ts-ignore
          onClick={onClick}
          {...renderProps}
          data-test-id={testId}
          to={to}
        >
          {content}
        </RouterLink>
      )}
    </BaseLink>
  )
})
